<!-- start media-selector -->
<div class="media-selector-container">
  <div class="row m-0 justify-center md:justify-normal">
    <div class="image-container" (click)="openUploader()">
      <div *ngIf="imgURL; else emptyImage" class="image-box"><div class="checkered-bg"> <img class="img-url" [src]="imgURL"/></div></div>
      <ng-template #emptyImage>
        <div class="empty-image">
          <div class = "image-center">
            +<br>
          {{ labelText | translate}}
        </div>
        </div>
      </ng-template>

    </div>
    <!-- <div class="col">
      <div (click)="openUploader()" class="btn btn-select btn-primary">{{(!imgURL?'Select Image':'Change Image') | translate}}</div>
      <div *ngIf="!!imgURL && showClearButton" (click)="clearSelected()" class="btn btn-select btn-outline-danger">Clear
        Selected</div>
    </div> -->
  </div>
</div>
<!-- end media-selector -->
